const routes = [
  {
    path: '/relatorio/pontuacao-detalhada',
    name: 'pontuacaoDetalhada',
    component: () => import('@/views/relatorio/equipe/PontuacaoDetalhada.vue'),
    meta: { breadcrumb: [{ title: 'Relatórios' }, { title: ' Recursos Humanos' }, { title: 'Detalhado de Pontuação' }] },
  },
  {
    path: '/relatorio/pontuacao-geral',
    name: 'pontuacaoGeral',
    component: () => import('@/views/relatorio/equipe/PontuacaoGeral.vue'),
    meta: { breadcrumb: [{ title: 'Relatórios' }, { title: ' Recursos Humanos' }, { title: 'Geral de Pontuação' }] },
  },
  {
    path: '/relatorio/pontuacao',
    name: 'pontuacao',
    component: () => import('@/views/relatorio/equipe/PontuacaoPorEquipe.vue'),
    meta: { breadcrumb: [{ title: 'Relatórios' }, { title: ' Equipes' }, { title: 'Pontuação' }] },
  },
  {
    path: '/relatorio/produtividade',
    name: 'produtividade',
    component: () => import('@/views/relatorio/equipe/Produtividade.vue'),
    meta: { breadcrumb: [{ title: 'Relatórios' }, { title: ' Equipes' }, { title: 'Produtividade' }] },
  },
]

export default routes
